import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import type { AchievementMilestone } from '@/modules/players/v3/types/achievements';

interface MilestoneBarProps {
  milestones: AchievementMilestone[];
}

export function MilestoneBar({ milestones }: MilestoneBarProps) {
  if (milestones.length <= 1) {
    return null;
  }

  const N = milestones.length;
  const lastAchievedIndex = milestones.reduce((last, m, i) => (m.achieved ? i : last), -1);
  const fillPercent =
    lastAchievedIndex < 0
      ? 0
      : lastAchievedIndex === N - 1
        ? 100
        : (lastAchievedIndex / (N - 1)) * 100;

  return (
    <div className='relative h-5 w-full'>
      <div className='absolute inset-0 bg-gray-200 rounded-full' />
      <div
        className='absolute inset-y-0 left-0 bg-success-200 rounded-full transition-all duration-300'
        style={{ width: `${fillPercent}%` }}
      />
      {milestones.map((milestone, index) => {
        const isFirst = index === 0;
        const isLast = index === N - 1;
        return (
          <div
            key={milestone.displayOrder}
            className={clsx(
              'absolute top-1/2 -translate-y-1/2',
              isFirst ? 'left-0' : isLast ? 'right-0' : '-translate-x-1/2'
            )}
            style={!isFirst && !isLast ? { left: `${(index / (N - 1)) * 100}%` } : undefined}
          >
            <FontAwesomeIcon
              icon={faCircleCheck}
              className={clsx('size-4', milestone.achieved ? 'text-success-400' : 'text-gray-300')}
            />
          </div>
        );
      })}
    </div>
  );
}
